<style scoped>

  .cell-row {
    height: 60px !important;
  }

  .ant-type-cell {
    width: 220px;
  }

  .ant-value-cell {
    width: 150px;
  }

  .ant-date-cell {
    width: 170px;
  }
  
</style>

<template>
  
  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <certs-filter ref="filter" @onApply="loadCerts" />

    <div v-if="loading && !certs" class="m-t-20"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <p v-if="certs && !certs.length && !loading" class="grey text m-t-30">
      <i class="info circle icon"></i> Nenhum laudo encontrado
    </p>

    <div v-if="certs && certs.length" class="ui basic segment no-padding no-margin animated fadeIn table-segment" :class="{ loading }">
      <table class="ui celled selectable tablet stackable table">
        <thead v-if="$isDesktop">
          <tr>
            <th>Laudo</th>
            <th>Financeiro</th>
            <th>Data</th>
            <th>Animal</th>
            <th>Ficha</th>
            <th>Tutor</th>            
            <th>Valor do Laudo</th>
            <th>Valor Recebido</th>
            <th>Antecipação</th>
            <th>Valor Antecipado</th>
            <th>Data Antecipação</th>
            <th></th>
          </tr>  
        </thead>        
        <tbody>
          <tr v-for="(cert, index) in certs" class="cell-row" @click="onRowClick($event, index)">
            <td>
              <strong class="mobile-only">Laudo: </strong> 
              <i :class="cert.certStatusData.icon"></i>
              {{ cert.id }}
            </td>
            <td>
              <strong class="mobile-only">Financeiro: </strong> 
              <i :class="cert.financialStatusData.icon"></i>
              {{ cert.financialStatusData.description }}
              <span v-if="cert.customerInvoiceId" class="ui label m-l-10">
                Fechamento <div class="detail">{{ cert.customerInvoiceId }}</div>
              </span>
            </td>
            <td>
              <strong class="mobile-only">Data: </strong> {{ $formatDate(cert.date) }}
            </td>
            <td>
              <strong class="mobile-only">Animal: </strong>
              <i v-if="cert.animal.sex == 'male'" class="mars blue icon"></i>
              <i v-else class="venus pink icon"></i>
              {{ cert.animal.name }}
            </td>
            <td>
              <strong class="mobile-only">Ficha: </strong> {{ cert.animalRegistration.registrationId }}
            </td>
            <td>
              <strong class="mobile-only">Tutor: </strong> {{ cert.owner.name }}
            </td>
            <td>
              <strong class="mobile-only">Valor do Laudo: </strong> R$ {{ $formatCurrency(cert.value) }}   
            </td>
            <td>
              <strong class="mobile-only">Valor Recebido: </strong> R$ {{ $formatCurrency(cert.fdata ? cert.fdata.receivedValue : 0) }}
            </td>
            <td class="ant-type-cell" @click="stopClickPropagation($event)">

              <strong class="mobile-only">Atencipação: </strong>

              <div class="ui pointing dropdown text cert-anticipations-grid-dropdown"  
                :class="{ black: !!cert.anticipation.action, grey: !cert.anticipation.action }">

                <span v-html="cert.anticipation.label"></span>                
                <i v-if="cert.anticipation.enabled" class="caret down icon" style="margin-left: 3px;"></i> 

                <div v-if="cert.anticipation.enabled" class="menu">
                  <div v-if="cert.anticipation.credit" class="item" @click="onSetAction($event, index, 'credit')">
                    <payment-type paymentType="credit" />
                  </div>
                  <div v-if="cert.anticipation.debit" class="item" @click="onSetAction($event, index, 'debit')">
                    <payment-type paymentType="debit" />
                  </div>
                  <div v-if="cert.anticipation.canRemove" class="item" @click="onSetAction($event, index, 'remove')">
                    <i class="times orange icon"></i>
                    Remover antecipação
                  </div>
                  <div class="item" @click="onSetAction($event, index, 'none')">
                    <i class="ban grey icon"></i>
                    Nenhuma ação
                  </div>
                </div>

              </div>

            </td>

            <td class="ant-value-cell" @click="stopClickPropagation($event)">
              <strong class="mobile-only">Valor Antecipado: </strong>              
              <value-input v-if="cert.anticipation.action == 'credit'" :index="index" :cert="cert" @onBlur="onBlurValueInput" />
              <value-input v-if="cert.anticipation.action == 'debit'" :index="index" :cert="cert" @onBlur="onBlurValueInput" />
              <span v-if="!cert.anticipation.action || cert.anticipation.action == 'remove'">
                R$ {{ $formatCurrency(cert.anticipationValue) }}
                <payment-type :paymentType="cert.anticipationType" :iconOnly="true" class="m-l-5" />
              </span>
            </td>

            <td class="ant-date-cell" @click="stopClickPropagation($event)">
              <strong class="mobile-only">Data Antecipação: </strong>              
              <date-input v-if="cert.anticipation.action == 'credit' || cert.anticipation.action == 'debit'" :index="index" :cert="cert" @onChangeDate="onChangeDate" />
              <span v-if="!cert.anticipation.action || cert.anticipation.action == 'remove'">
                {{ $formatDate(cert.anticipationDate) }}
              </span>
            </td>

            <td class="details-cell">
              <button class="ui small icon button" @click="onShowCert($event, cert.id)">
                <i class="search plus icon"></i>
              </button>
            </td>

          </tr>                
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="bold text">R$ {{ $formatCurrency(totals.certValue) }}</td>
            <td class="bold text">R$ {{ $formatCurrency(totals.receivedValue) }}</td>
            <td></td>
            <td class="bold text">R$ {{ $formatCurrency(totals.anticipationValue) }}</td>
            <td></td>
            <td></td>
          </tr>
        </tfoot>
      </table>      
    </div>

    <button v-if="certs && certs.length" class="ui right floated blue button m-t-15" 
      :class="{ disabled: !anticipations.length, loading: saving }" @click="onConfirm()">
      <i class="check icon"></i> Confirmar
    </button>

    <!-- This is for calendar visibility in table -->  
    <div style="height: 150px;"></div>

  </div>

</template>

<script>

  import { AppBrowser, moment } from "@/utils"
  import { BookmarkButton, PaymentType } from "@/components"
  import onlyFinancial from "@/mixins/only-financial"
  import CertService from "@/services/cert-service"
  import CustomerService from "@/services/customer-service"
  import SrvService from "@/services/srv-service"  
  import FinancialService from "@/services/financial-service"  
  import CertsFilter from "./filter.vue"
  import ValueInput from "./value-input"
  import DateInput from "./date-input"

  const service = new CertService()
  const customerService = new CustomerService()

  export default {
    
    name: "CertsAnticipationPage",

    mixins: [onlyFinancial],

    data() {
      return {       
        loading: false,
        saving: false,
        certs: null,
        customer: null,
        totals: {},
        title: "Antecipações de Laudos",        
      }
    },

    components: {
      BookmarkButton,
      PaymentType,
      CertsFilter,
      ValueInput,
      DateInput,
    },

    computed: {

      anticipations() {

        if (!this.certs)
          return []             

        let anticipations = []        

        for (const cert of this.certs) {
          if (cert.anticipation.action) {
            anticipations.push({
              certId: cert.id,
              type: cert.anticipation.action,
              value: cert.anticipation.value,
              date: cert.anticipation.date,
            })
          }
        }

        return anticipations
      },      
    },

    methods: {

      async loadCerts(filter) {
        
        this.loading = true
        this.certs = null

        try {

          let certs = await service.filter({
            startDate: moment(filter.startDate).format("YYYY-MM-DD"),
            endDate: moment(filter.endDate).format("YYYY-MM-DD"),
            customerId: filter.customer.id,
            order: "date",
          })

          if (!this.customer)
            this.customer = await customerService.findById(filter.customer.id)

          certs.forEach(this.setCertData)          

          this.certs = certs.slice()

          this.updateTotals()

          setTimeout(() => this.loadGridDropdowns(), 800)
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.loading = false
        }
      },      

      loadGridDropdowns() {
        $(".cert-anticipations-grid-dropdown").dropdown()
      },

      hideGridDropdowns() {
        $(".cert-anticipations-grid-dropdown").dropdown("hide")
      },

      setCertData(cert) {        

        cert.certStatusData = CertService.STATUS[cert.status]
        cert.financialStatusData = CertService.FINANCIAL_STATUS[cert.fdata ? cert.fdata.status : "uninformed"]
        cert.serviceTypeData = SrvService.TYPE_ICONS[cert.serviceType.icon]
        
        const creditValue = this.getAnticipationValue("credit", cert)
        const debitValue = this.getAnticipationValue("debit", cert)

        cert.anticipation = {     
          creditValue,
          debitValue,
          credit: !!creditValue,
          debit: !!debitValue,
          enabled: (!!creditValue || !!debitValue),
          canRemove: (!!cert.anticipationValue),
        }

        if (cert.customerInvoiceId)
          cert.anticipation.enabled = false

        this.setActionData(cert)
      },

      getAnticipationValue(type, cert) {

        let value = 0

        for (const srv of this.customer.services) { 
          if (srv.serviceId == cert.serviceId && srv.serviceTypeId == cert.serviceTypeId) {
            value = type == "credit" ? srv.creditAnticipation : srv.debitAnticipation
          }
        }

        return value
      },

      onRowClick($event, index) {

        $event.stopPropagation()

        const cert = this.certs[index]

        if (!cert.anticipation.enabled || !!cert.anticipation.action)
          return

        if (cert.anticipation.credit && !cert.anticipation.debit) {
          this.onSetAction($event, index, "credit")
        } else if (cert.anticipation.debit && !cert.anticipation.credit) {
          this.onSetAction($event, index, "debit")
        } 
      },

      stopClickPropagation($event) {        
        $event.stopPropagation()
      },

      onSetAction($event, index, action) {

        $event.stopPropagation()

        this.hideGridDropdowns()

        let certs = this.certs.slice()

        certs[index].anticipation.action = "none"

        this.certs = certs.slice()

        setTimeout(() => this.updateAction(index, action), 80)
      },

      updateAction(index, action) {        
          
        let certs = this.certs.slice()
        
        certs[index].anticipation.action = action      
        
        this.setActionData(certs[index])

        this.certs = certs.slice()

        this.updateTotals()
      },

      setActionData(cert) {

        let label =  ""
        let value = 0
        let { date, action } = cert.anticipation

        if (action == "credit") {
          
          value = cert.anticipation.creditValue
          label = FinancialService.PAYMENT_TYPE.credit.label

        } else if (action == "debit") {

          value = cert.anticipation.debitValue
          label = label = FinancialService.PAYMENT_TYPE.debit.label

        } else if (action == "remove") {

          date = null
          label = '<i class="times orange icon"></i> Remover antecipação'  
          
        } else {  

          action = ""  
          label = '<i class="ban grey icon"></i> Nenhuma ação'
        }

        cert.anticipation.value = value
        cert.anticipation.date = date
        cert.anticipation.label = label          
        cert.anticipation.action = action

        return label
      },

      onBlurValueInput(data) {
        
        const { index, value } = data
        
        let certs = this.certs.slice()
        
        certs[index].anticipation.value = value

        this.certs = certs.slice()

        this.updateTotals()
      },

      onChangeDate(data) {
        
        const { index, date } = data
        
        let certs = this.certs.slice()
        
        certs[index].anticipation.date = moment(date).format("YYYY-MM-DD")

        this.certs = certs.slice()
      },

      onShowCert($event, id) {
        
        $event.stopPropagation()

        AppBrowser.openNewTab(`/procs/certs/${id}/show`)
      },   

      updateTotals() {

        let certValue = 0
        let receivedValue = 0
        let anticipationValue = 0

        for (const cert of this.certs) {

          certValue += cert.value          
          receivedValue += cert.fdata ? cert.fdata.receivedValue : 0

          if (cert.anticipation.action == "credit" || cert.anticipation.action == "debit") {
            anticipationValue += cert.anticipation.value
          } else if (cert.anticipationValue) {
            anticipationValue += cert.anticipationValue
          }
        }

        this.$set(this.totals, "certValue", certValue)
        this.$set(this.totals, "receivedValue", receivedValue)
        this.$set(this.totals, "anticipationValue", anticipationValue)
      },

      async onConfirm() {

        if (this.saving)
          return

        this.saving = true  

        try {

          await service.updateAnticipations(this.anticipations)

          this.certs = null
          this.$refs.filter.clear()

          this.$msg.success("Laudos atualizados com sucesso")

          AppBrowser.scrollTop()
          
        } catch (error) {
          
          this.$errorHandler(error)
        
        } finally {

          this.saving = false
        }
      },
    },
  }

</script>